import { get } from 'lodash';

function fetchBootstrap() {
  const url = `${get(window, 'uuSettings.api-url', '')}system/bootstrap`;

  const http = new XMLHttpRequest();
  return new Promise((resolve, reject) => {
    http.onreadystatechange = () => {
      if (http.readyState === 4) {
        const resp = JSON.parse(http.responseText);
        if (resp.error) {
          reject(resp.error);
        } else {
          resolve(resp);
        }
      }
    };
    http.open('GET', url);
    http.send();
  });
}

export default fetchBootstrap;



// WEBPACK FOOTER //
// ./public/js/actions/fetchBootstrap.js